import posthog from 'posthog-js';
import ENV from '../../../environment';
import type {AnalyticsSink} from '../types';

// Mirrors initPostHog(): without a key the client is never initialised.
const enabled = () => !!ENV.POSTHOG_KEY;

export const posthogSink: AnalyticsSink = {
  name: 'posthog',
  track(name, props) {
    if (enabled()) posthog.capture(name, props);
  },
  page(name, props) {
    if (enabled()) posthog.capture('$pageview', {...props, screen_name: name});
  },
  identify(userId, traits) {
    if (enabled()) posthog.identify(userId, traits);
  },
  setUserProperties(props) {
    if (enabled()) posthog.setPersonProperties(props);
  },
  reset() {
    if (enabled()) posthog.reset();
  },
};
